import { createSelector } from '@reduxjs/toolkit';
import { selectActivation } from '../../store/selectors';

export const selectValidationMessages = createSelector(selectActivation, (activation) => activation?.validationMessages);

export const selectStatus = createSelector(selectActivation, (activation) => activation?.status);
